import {
  getApiUrl,
  getInvoicesInvoiceIDPdfPath,
  getJwtKey,
} from "Infrastructure/Api/Api";

export async function downloadInvoicePdf(invoiceID: string): Promise<void> {
  const url = `${getApiUrl()}${getInvoicesInvoiceIDPdfPath(invoiceID)}`;
  const token = getJwtKey();
  const response = await fetch(url, {
    headers: token ? { Authorization: token } : {},
  });
  if (!response.ok) throw new Error("Failed to download invoice PDF");
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = `invoice-${invoiceID}.pdf`;
  a.click();
  URL.revokeObjectURL(blobUrl);
}
